// Master dropdown options for the Lodge Encounter form.

export const ENCOUNTER_TYPES = [
    "sighting", "close-encounter", "abduction", "being-encounter",
    "telepathic-contact", "missing-time", "dream-contact",
    "astral-contact", "interdimensional", "channeled-contact",
    "mass-sighting", "physical-trace", "military", "other",
];

export const REALITY_TYPES = ["physical", "dreamlike", "astral", "interdimensional", "unknown"];

export const KNOWN_ENTITY_TYPES = [
    "Grey", "Tall Grey", "Mantid", "Reptilian", "Nordic", "Shadow Being",
    "Orb Intelligence", "Hybrid", "Unknown", "Other",
];

export const HEIGHTS = [
    "Under 0.5m", "0.5–1m", "1.0–1.4m", "1.4–1.7m", "1.7–2.0m",
    "2.0–2.5m", "Over 2.5m", "Unknown", "Other",
];

export const BUILDS = ["Slight", "Slender", "Average", "Muscular", "Bulky", "Insectoid", "Amorphous", "Other"];

export const SKIN_COLOURS = [
    "Grey", "Pale grey", "White", "Green", "Brown", "Black",
    "Reptilian green", "Translucent", "Metallic silver", "Iridescent", "Other",
];

export const SKIN_TEXTURES = ["Smooth", "Leathery", "Scaled", "Chitinous", "Wet/slimy", "Hairy", "Cloth-covered", "Self-luminous", "Other"];

export const EYE_SHAPES = ["Large almond", "Wraparound", "Round", "Compound (insect)", "Human-shaped", "No visible eyes", "Glowing", "Other"];

export const PUPIL_TYPES = ["Solid black", "Vertical slit", "Horizontal slit", "Round human-like", "Glowing", "No visible pupil", "Other"];

export const EYE_COUNTS = ["1", "2", "3", "4", "Multiple/compound", "Other"];

export const HEAD_SHAPES = ["Oversized oval", "Elongated", "Triangular", "Insectoid", "Human", "Reptilian", "Featureless", "Other"];

export const MOUTH_TYPES = ["Slit", "Vestigial", "Mandibles", "Human-like", "Beak", "None", "Other"];

export const NOSE_TYPES = ["None visible", "Two nostrils", "Slits", "Snout", "Human-like", "Other"];

export const FINGER_COUNTS = ["2", "3", "4", "5", "6+", "Claws", "Tentacles", "Other"];

export const LIMB_COUNTS = ["2", "4", "6", "8", "More than 8", "Unknown", "Other"];

export const LEG_STRUCTURES = ["Bipedal (straight)", "Bipedal (digitigrade)", "Quadrupedal", "No visible legs", "Levitating", "Other"];

export const BODY_SHAPES = ["Humanoid", "Insectoid", "Reptilian", "Amorphous", "Orb / spherical", "Cloaked silhouette", "Other"];

export const HAIR_OPTIONS = ["None", "Sparse", "Short", "Long blond", "Long white", "Long dark", "Wisp/feathery", "Other"];

export const CLOTHING_OPTIONS = ["None / nude", "Tight-fitting suit", "Cloak/robe", "Reflective armor", "Uniform", "Loose garment", "Crystalline", "Other"];

export const MOVEMENT_STYLES = ["Walked", "Glided", "Floated", "Teleported", "Phased through walls", "Insect-quick", "Slow deliberate", "Other"];

export const COMMUNICATION_STYLES = ["Telepathic", "Spoken language", "Tones/clicks", "Light pulses", "No communication", "Symbol projection", "Other"];

export const EMOTIONAL_ATMOSPHERE = [
    "Fearful", "Calm", "Loving", "Cold/clinical", "Awe / reverence",
    "Overwhelmed", "Disorientation", "Peaceful", "Hostile", "Curious", "Other",
];

export const SOUND_OPTIONS = ["Silent", "Hum", "Buzz", "Clicks", "Music/tones", "Mechanical", "Wind/rushing", "Other"];

export const SMELL_OPTIONS = ["None", "Sulfur", "Ozone", "Burnt metal", "Sweet", "Floral", "Wet earth", "Other"];

export const VIBRATION_OPTIONS = ["None", "Static / electric", "Body buzzing", "Pressure on chest", "Paralysis", "Warmth", "Cold chill", "Other"];

export const TECHNOLOGY_OPTIONS = ["None visible", "Wand/rod", "Light beam", "Tablet/screen", "Implants/needles", "Holographic display", "Other"];

export const CRAFT_TYPES = [
    "None observed", "Disc", "Saucer", "Triangle", "Cigar", "Tic-Tac", "Sphere/Orb",
    "V-formation", "Boomerang", "Egg", "Cube", "Pyramid", "Diamond", "Other",
];

export const EVIDENCE_LEVELS = ["none", "testimony", "photo", "video", "physical", "multiple"];

export const ORIGIN_SYSTEMS = [
    "Unknown", "Zeta Reticuli", "Pleiades", "Sirius", "Orion", "Andromeda",
    "Arcturus", "Lyra", "Vega", "Local", "Inner Earth", "Other dimension", "Other",
];
